/**
 * Apollo Client para páginas públicas (sin sesión Keycloak).
 *
 * Diferencia con ApolloProvider.js (privado):
 *   - No inyecta `Authorization: Bearer <token>` ni `x-hasura-role` (no hay sesión).
 *   - Inyecta el header `PORT_METADATA` para que el microservicio publicAccess
 *     identifique el esquema/DB a consultar (yard, operator, complex, facility).
 *
 * Por qué el header solo va aquí y no en el privado:
 *   - En rutas autenticadas el backend resuelve el tenant a partir del JWT.
 *   - Duplicarlo en el privado crearía dos fuentes de verdad.
 *
 * Nota sobre Hasura:
 *   - Las queries públicas (umTypeUserPublic, umRegisterUserPublic, etc.) son Actions/Remote
 *     Schemas que llaman al microservicio publicAccess. Para que el header llegue al upstream,
 *     la Action/Remote Schema en Hasura debe tener `forward_client_headers: true`.
 */
import React from 'react'
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink, ApolloLink } from '@apollo/client'
import configmap from '../config.json'

const url_graphql = configmap.REACT_APP_GRAPHQL_ENDPOINT
// Resuelto una sola vez al cargar el módulo: el valor proviene del ConfigMap y no cambia
// durante el ciclo de vida de la app. Evita re-parsear el JSON en cada operación.
// inicio captura valores del configmap
console.log('PUBLIC_REDIRECT_VVF', configmap.PUBLIC_REDIRECT_VVF)

const yardid = configmap.REACT_APP_PORT_YARDID
const operatorid = configmap.REACT_APP_PORT_OPERATORID
const complexid = configmap.REACT_APP_PORT_COMPLEXID
const facilityid = configmap.REACT_APP_PORT_FACILITYID

console.log('yardid', (yardid || 'Valor no disponible'))
console.log('operatorid', (operatorid || 'Valor no disponible'))
console.log('complexid', (complexid || 'Valor no disponible'))
console.log('facilityid', (facilityid || 'Valor no disponible'))

const portMetadataHeaderValue = {
    "yard-id": yardid || "",
    "operator-id": operatorid || "",
    "complex-id": complexid || "",
    "facility-id": facilityid || ""
    
}
console.log('portMetadataHeaderValue', portMetadataHeaderValue)

const ApolloAuthProvider = ({ children }) => {
    const httpLink = new HttpLink({ uri: url_graphql })

    const authLink = new ApolloLink((operation, forward) => {
        operation.setContext(({ headers = {} }) => ({
            headers: {
                ...headers,
                // Spread condicional: si el valor es null (configmap ausente o inválido),
                // se omite la key entera para evitar enviar `PORT_METADATA: undefined`,
                // que el backend interpretaría como string literal "undefined".
                ...({ 'PORT_METADATA': btoa(JSON.stringify(portMetadataHeaderValue)) } ),
                ...({ 'PORTMETADATA': JSON.stringify(portMetadataHeaderValue) } ),
                ...({ 'PORTMETADATAFACILITY': portMetadataHeaderValue["facility-id"] })
            }
        }))
        return forward(operation)
    })

    const client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache: new InMemoryCache()
    })

    return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default ApolloAuthProvider
